import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router } from '@angular/router';
import { CommonService } from 'src/app/services/common.service';
import { ApilistService } from 'src/app/services/apilist.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GlobalService } from 'src/app/services/global.service';
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-signin',
  templateUrl: './signin.component.html',
  styleUrls: ['./signin.component.scss'],
  standalone: true, // ✅ add this
  imports: [CommonModule, FormsModule, ReactiveFormsModule], // add any modules it uses
})
export class SigninComponent implements OnInit {
  email: any;
  paswdValue: any;
  confirmPassValue: any;
  showErr = false;

  showLogin = true;
  showEmailverify = false;
  showOTPverify = false;
  showforgotPass = false;
  user_id: any;
  userDetails: any;
  otp: any;
  loginForm: UntypedFormGroup;
  emailVerifyForm: UntypedFormGroup;
  otpVerifyForm: UntypedFormGroup;
  changePassForm: UntypedFormGroup;

  submitted = false;

  @ViewChild('boxForgot', { static: false }) boxForgot: ElementRef;

  error_messages = {
    emailid: [
      { type: 'required', message: 'please enter email address.' },
      { type: 'pattern', message: 'Please enter a valid email address.' },
    ],
    password: [
      { type: 'required', message: 'Password is required.' },
      // { type: 'minlength', message: 'password length.' },
    ],
    verifyotp: [
      { type: 'required', message: 'OTP is required.' },
      { type: 'maxlength', message: 'OTP should be 8 digit' },
      { type: 'minlength', message: 'OTP should be 4 digit' },
      { type: 'pattern', message: 'OTP should be Numbers only' },
    ],
  };

  constructor(
    private router: Router,
    public utils: ApilistService,
    public commonservice: CommonService,
    private SpinnerService: NgxSpinnerService,
    public globalService: GlobalService,
    public formBuilder: UntypedFormBuilder,
    private spinner: NgxSpinnerService
  ) {
    this.loginForm = this.formBuilder.group({
      emailid: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.email,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ])
      ),

      paswd: new UntypedFormControl(
        '',
        Validators.compose([Validators.required, Validators.maxLength(30)])
      ),
    });

    this.emailVerifyForm = this.formBuilder.group({
      verifyEmail: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.email,
          Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$'),
        ])
      ),
    });

    this.otpVerifyForm = this.formBuilder.group({
      verifyOtp: new UntypedFormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.minLength(4),
          Validators.maxLength(8),
          Validators.pattern(/^-?(0|[1-9]\d*)?$/),
        ])
      ),
    });

    this.changePassForm = this.formBuilder.group(
      {
        paswd: new UntypedFormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(30),
          ])
        ),

        confirmPass: new UntypedFormControl(
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(6),
            Validators.maxLength(30),
          ])
        ),
      },
      {
        validators: this.password.bind(this),
      }
    );
  }

  ngOnInit(): void {
    this.changePassForm.reset();
    this.loginForm.reset();
    this.emailVerifyForm.reset();
    this.otpVerifyForm.reset();
  }

  password(formGroup: UntypedFormGroup) {
    const { value: password } = formGroup.get('paswd');
    const { value: confirmPassword } = formGroup.get('confirmPass');
    this.paswdValue = password;
    if (password === confirmPassword) {
      this.showErr = false;
    } else {
      this.showErr = true;
    }
  }

  signin() {
    this.spinner.show();

    let payload = {
      email_id: this.email,
      password: this.paswdValue,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('weblogin');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          this.spinner.hide();
          // let temp = resp.data;
          this.userDetails = resp.data;
          // console.log("login resp", this.userDetails);
          this.globalService.setLocalStore(
            'adminDetails',
            JSON.stringify(this.userDetails)
          );
          this.user_id = this.userDetails[0].id;
          // console.log("user id", this.user_id);
          this.router.navigate(['/dashboard']);
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.Messages);
          this.globalService.showError(resp.Messages);
        }
      });
    // this.router.navigate(['dashboard']);
  }

  forgotPassword() {
    this.showLogin = false;
    this.showEmailverify = true;
    this.showOTPverify = false;
    this.showforgotPass = false;
  }

  verify() {
    this.spinner.show();
    let user = JSON.parse(localStorage.getItem('adminDetails'));
    this.userDetails = JSON.parse(user);
    // console.log("user", this.userDetails);
    this.user_id = this.userDetails[0].id;

    // this.user_id = this.userDetails[0].id;
    // console.log("user", this.user_id);

    let payload = {
      email_id: this.email,
      user_id: this.user_id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('otp');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.SpinnerService.hide();
        this.spinner.hide();
        if (resp.status_code == '200') {
          // console.log(resp.data);
          this.spinner.hide();
          this.globalService.showSuccess(
            'OTP has been send to your Email. Please Verify.'
          );
          this.showLogin = false;
          this.showEmailverify = false;
          this.showOTPverify = true;
          this.showforgotPass = false;
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.message);
          this.globalService.showError(resp.message);
        }
      });
  }

  verifyOTP() {
    this.spinner.show();
    let user = JSON.parse(localStorage.getItem('adminDetails'));
    this.userDetails = JSON.parse(user);
    // console.log("user", this.userDetails);
    this.user_id = this.userDetails[0].id;
    // console.log("user", this.user_id);

    let payload = {
      otp: this.otp,
      user_id: this.user_id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('verifyotp');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          // console.log(resp.data);
          this.spinner.hide();
          this.globalService.showSuccess('OTP verified successfully.');
          this.showLogin = false;
          this.showEmailverify = false;
          this.showOTPverify = false;
          this.showforgotPass = true;
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.message);
          this.globalService.showError(resp.message);
        }
      });
  }

  resend() {
    this.verify();
  }

  backToLogin() {
    this.showLogin = true;
    this.showEmailverify = false;
    this.showOTPverify = false;
  }

  onMouseOver(e) {
    (<HTMLDivElement>this.boxForgot.nativeElement).style.pointerEvents = 'auto';
    (<HTMLDivElement>this.boxForgot.nativeElement).style.cursor = 'pointer';
  }

  changePassword() {
    this.spinner.show();
    let user = JSON.parse(localStorage.getItem('adminDetails'));
    this.userDetails = JSON.parse(user);
    this.user_id = this.userDetails[0].id;
    // console.log("user", this.user_id);
    // console.log("Password", this.paswdValue);

    let payload = {
      password: this.paswdValue,
      user_id: this.user_id,
    };
    // console.log("payload", payload);
    const servicePath = this.utils.getApiConfigs('editpassword');
    this.commonservice
      .invokeService(servicePath[0].method, servicePath[0].path, payload)
      .then((resp: any) => {
        // console.log("resp", resp);
        this.spinner.hide();
        if (resp.status_code == '200') {
          // console.log(resp.data);
          this.spinner.hide();
          this.globalService.showSuccess(resp.data);
          this.showLogin = true;
          this.showEmailverify = false;
          this.showOTPverify = false;
          this.showforgotPass = false;
          this.ngOnInit();
        } else if (resp.status_code == '400') {
          this.spinner.hide();
          // console.log("data", resp.message);
          this.globalService.showError(resp.message);
        }
      });
  }
}
